import i from "../../config/index.js";
import * as t from "ramda";
const n = (o = []) => t.includes(i.VARIABLES.ENV, o), r = () => typeof window < "u", s = () => n(["production"]), c = () => n(["development", "staging"]);
export {
  c as isAllowScreenLog,
  r as isClientSide,
  s as isProduction,
  n as isUsingEnv
};
//# sourceMappingURL=index.js.map
